import React, { Fragment } from 'react'
import  reactDOM  from 'react-dom'
import Card from "./Cards"
import {useModalContext} from "../context/modal-context"
import "./modal.css"

const Modal = ({className, children}) => {
	const{showModal, closeModalHandler} = useModalContext();

	return (
		<Fragment>
		{
			showModal && reactDOM.createPortal(<>
				<section id="backdrop" onClick={closeModalHandler}></section>
		   <Card className={className}>{children}</Card>
				</>, document.querySelector("#overlays")
			)
		}
		
		</Fragment>
		
	)
}

export default Modal